import { updateCartCountDisplay } from "../../utils/cart"

class SimpleProduct {
    constructor(el) {
        this.el = el
        this.button = el.querySelector("[data-product-add-to-cart][data-product-type='simple']")
        this.buttonLabel = this.button ? this.button.querySelector("[data-button-label]") : null
        this.viewCartLink = el.querySelector("[data-view-cart]")
        this.quantityInput = el.querySelector("[data-qty-input]")
        this.ajaxUrl = el.dataset.ajaxUrl || (typeof window !== "undefined" ? window.ajaxurl : null)
        this.productId = this.button ? this.button.dataset.productId : null
        this.buttonStateBeforeLoading = null
        this.originalButtonLabel = this.buttonLabel ? this.buttonLabel.textContent.trim() : ""

        this.handleAddToCart = this.handleAddToCart.bind(this)

        this.init()
    }

    init() {
        if (!this.button || !this.ajaxUrl || !this.productId) {
            return
        }

        this.button.addEventListener("click", this.handleAddToCart)
    }

    getQuantity() {
        if (!this.quantityInput) {
            return 1
        }

        const value = parseInt(this.quantityInput.value, 10)
        if (Number.isNaN(value) || value <= 0) {
            return 1
        }

        const min = this.quantityInput.getAttribute("min")
        const max = this.quantityInput.getAttribute("max")

        let quantity = value

        if (min !== null) {
            quantity = Math.max(quantity, parseInt(min, 10) || 1)
        }

        if (max !== null && !Number.isNaN(parseInt(max, 10))) {
            quantity = Math.min(quantity, parseInt(max, 10))
        }

        return quantity
    }

    setLoading(isLoading) {
        if (!this.button) {
            return
        }

        if (isLoading) {
            this.buttonStateBeforeLoading = {
                disabled: this.button.disabled,
            }

            this.button.classList.add("is-loading")
            this.button.disabled = true
            this.button.setAttribute("aria-busy", "true")
        } else {
            // Check if view cart link is visible - if so, keep button hidden
            const shouldKeepButtonHidden = this.viewCartLink && !this.viewCartLink.hidden

            if (this.buttonStateBeforeLoading) {
                this.button.disabled = this.buttonStateBeforeLoading.disabled
            } else {
                this.button.disabled = false
            }

            // Keep button hidden if view cart link is visible
            if (shouldKeepButtonHidden) {
                this.button.hidden = true
                this.button.setAttribute("hidden", "")
            }

            this.button.classList.remove("is-loading")
            this.button.setAttribute("aria-busy", "false")
            this.buttonStateBeforeLoading = null
        }
    }

    showViewCartLink() {
        if (!this.viewCartLink) {
            return
        }

        this.viewCartLink.hidden = false
        this.viewCartLink.removeAttribute("hidden")
        
        // Hide the "Add to cart" button
        if (this.button) {
            this.button.hidden = true
            this.button.setAttribute("hidden", "")
        }
    }

    flashSuccessState() {
        if (!this.buttonLabel || !this.originalButtonLabel) {
            return
        }

        this.buttonLabel.textContent = "ajouté !"

        window.setTimeout(() => {
            this.buttonLabel.textContent = this.originalButtonLabel
        }, 2000)
    }

    async handleAddToCart(event) {
        event.preventDefault()

        if (!this.ajaxUrl || !this.productId) {
            console.error("Add to cart configuration is incomplete")
            return
        }

        const quantity = this.getQuantity()

        const payload = new URLSearchParams()
        payload.append("action", "lc_add_to_cart")
        payload.append("product_id", this.productId)
        payload.append("add-to-cart", this.productId)
        payload.append("quantity", quantity)

        this.setLoading(true)

        try {
            const response = await fetch(this.ajaxUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
                body: payload.toString(),
            })

            const result = await response.json()

            if (!response.ok || !result || !result.success) {
                const errorMessage = result?.data?.message || "Impossible d'ajouter le produit au panier."
                throw new Error(errorMessage)
            }

            this.showViewCartLink()
            this.flashSuccessState()

            if (result?.data?.cart_count !== undefined) {
                updateCartCountDisplay(result.data.cart_count)

                window.dispatchEvent(
                    new CustomEvent("cart:updated", {
                        detail: {
                            count: result.data.cart_count,
                        },
                    })
                )
            }
        } catch (error) {
            console.error(error)
        } finally {
            this.setLoading(false)
        }
    }
}

export default SimpleProduct